/** Row of `public.entitlements` (SPEC.md §6.2). */
export interface EntitlementRow {
  plan: 'yearly' | 'lifetime';
  status: 'active' | 'past_due' | 'canceled' | 'refunded';
  current_period_end: string | null;
}

export type EntitlementState = 'none' | 'active' | 'grace' | 'lapsed';

export const GRACE_DAYS = 14;
const DAY_MS = 24 * 60 * 60 * 1000;

/** Must match `public.my_entitlement_state()` in supabase/migrations. */
export function entitlementState(row: EntitlementRow | null | undefined, now: Date = new Date()): EntitlementState {
  if (!row || row.status === 'refunded') return 'none';
  if (row.plan === 'lifetime') return 'active';
  if (!row.current_period_end) return 'lapsed';
  const end = new Date(row.current_period_end).getTime();
  if (now.getTime() < end) return 'active';
  if ((row.status === 'active' || row.status === 'past_due') && now.getTime() < end + GRACE_DAYS * DAY_MS) return 'grace';
  return 'lapsed';
}

/** Whether the app may write. Lapsed plans are read-only; `none` never reaches the app (paywall). */
export function canWrite(state: EntitlementState) {
  return state === 'active' || state === 'grace';
}
